import React from 'react';
import { Notification, SmallBodyText } from '../../../../../ui-toolkit';
import { ePartyPurpose } from '../../../../../ui-toolkit/enums/ePartyPurpose';

const getNotificationText = (isNew: boolean) => {
  return `${isNew ? 'Adding' : 'Changing'} a party ${
    isNew ? 'to' : 'on'
  } an order can cause documents to be regenerated`;
};
export const PartyNotificationMessage: React.FC<{ isNew: boolean; partyPurpose: ePartyPurpose }> = ({
  isNew,
  partyPurpose,
}) => {
  const notificationMessageText = getNotificationText(isNew);
  if (partyPurpose === ePartyPurpose.order_contact) {
    return null;
  }
  return (
    <Notification
      type={`warning`}
      mode={`inverted`}
      message={<SmallBodyText>{notificationMessageText}</SmallBodyText>}
    />
  );
};
